import { Paper, Stack, Typography } from "@mui/material";
import { type FC, type ReactNode } from "react";

export const FollowUpBodySection: FC<{
  title: string;
  subtitle: string;
  children: ReactNode;
}> = ({ title, subtitle, children }) => {
  return (
    <Paper elevation={5} sx={{ p: 4 }}>
      <Stack direction="column" spacing={2}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body1">{subtitle}</Typography>
        {children}
      </Stack>
    </Paper>
  );
};
